// extracted by mini-css-extract-plugin
export var label = "_j1-0";
export var treatmentCard = "_j1-1";